import RxTitleSeperator from "./RxTitleSeperator";

export default RxTitleSeperator;
